__turbopack_context__.v({
  "adornmentIcon": "roXUJq_adornmentIcon",
  "clearIndicator": "roXUJq_clearIndicator",
  "input": "roXUJq_input",
  "listBox": "roXUJq_listBox",
  "menu": "roXUJq_menu",
  "menuItem": "roXUJq_menuItem",
  "popupIndicator": "roXUJq_popupIndicator",
  "select": "roXUJq_select",
});
